<template>
    <section class="dd-m-banner dd-m-banner--quiz" v-if="banner">
        <div class="banner-text" >
            <h2 class="banner-main-title">{{banner.title}}</h2>
            <span class="banner-main-subtitle">{{banner.description}}</span>
            <div class="banner-quiz-question">
                <span class="question-text">{{ getTranslateString('Who is your AVON fragrance for?')}}</span>
                
                <ul class="answers">
                    <li><a :href="getQuizLink('Male')">{{getTranslateString('Him')}}</a></li>
                    <li><a :href="getQuizLink('Female')">{{getTranslateString('Her')}}</a></li>
                    <li><a :href="getQuizLink('Unisex')">{{getTranslateString('Unisex')}}</a></li>
                </ul>
            </div>
        </div>
        <img class="banner-image desktop" :src="banner.image.desktop" :alt="banner.title">
        <img class="banner-image tablet" :src="banner.image.tablet" :alt="banner.title">
        <img class="banner-image mobile" :src="banner.image.mobile" :alt="banner.title">
        
    </section>
    
</template>

<script>
//import BannerService from "../../providers/api/banner-service";

import BannerService from "../../providers/api/banner-service";
import Loading from "../loading";

let bannerService = new BannerService();

export default {
    name: 'banner-quiz',

	data: () => {
		return {
			results: [],
			isLoading: false,
			show: true,
			banner: false,
			language: language,
			language_is_default: language_is_default,
		}
	},
    
	mounted() {
		this.loadBanner();
	},
	methods: {
		getQuizLink(gender = "Male"){
			var returnValue = "";
			var urlEncodedGender = encodeURIComponent(gender);

			if(!this.language_is_default){
				returnValue = returnValue.concat(`/${language}`);
			}

			returnValue = returnValue.concat(`/quiz/perfect-perfume?g=${urlEncodedGender}`);

			return returnValue;
		},
	
		loadBanner(){
			this.isLoading = true;

			const params = {
				perPage: 1
			};
			bannerService.doGetByType(100, params).then((res) => {
				this.banner = res.data.data[0];
				this.isLoading = false;
			})
			.catch(() => this.isLoading = false);
		}
	}

}
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-quiz.vue